import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectRoutingModule } from './project-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { DetailsProjectComponent } from './components/details-project/details-project.component';

@NgModule({
  declarations: [DetailsProjectComponent],
  imports: [
    CommonModule,
    ProjectRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatTableModule,
    NgbModule,
    PaginationModule,
    FieldErrorModule,
    NgSelectModule,
  ],
})
export class ProjectModule {}
